import {StickerType, Tag} from 'yougile-model'
import {StickerSettingsState} from '@components/sticker/my-stickers/board-stickers/sticker-settings/types'
import {Sticker} from '@extensions/sticker/sticker'

const stickerTypesWithAutomations: StickerType[] = [
  'string',
  'sprint',
  'user',
  'stopwatch',
  'deadline',
  'text',
  'numeric'
]

export const hasAutomations = (sticker: Tag): boolean =>
  stickerTypesWithAutomations.includes(Sticker.getType(sticker))

export const getAutomationsCount = (
  sticker: Tag,
  settings: StickerSettingsState
): number => {
  const type = Sticker.getType(sticker)

  let count = 0

  const isRequired =
    settings.required && ['offer', 'require'].includes(settings.required)
  count += Number(isRequired ?? false)
  if (type === 'sprint') {
    count += Number(settings.filterByCurrentValue ?? true)
  }
  count += Number(settings.hasDefaultState ?? false)
  count += Number(settings.shouldResetOnMove ?? false)
  count += Number(settings.shouldStopWhenCompleted ?? false)
  count += Number(settings.showNumericStickersSum ?? false)
  count += Number(settings.titleBeforeValue ?? false)

  return count
}
